// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/delivery.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.DeliveryMethodConfig
 */
export const DeliveryMethodConfig = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeliveryMethodConfig",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "supported_countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "config", kind: "message", T: Struct },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ShippingRate
 */
export const ShippingRate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ShippingRate",
  () => [
    { no: 1, name: "method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "method_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "estimated_days_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "estimated_days_max", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.Shipment
 */
export const Shipment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Shipment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "delivery_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "provider_shipment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tracking_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "tracking_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "label_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "origin", kind: "message", T: Struct },
    { no: 11, name: "destination", kind: "message", T: Struct },
    { no: 12, name: "metadata", kind: "message", T: Struct },
    { no: 20, name: "events", kind: "message", T: ShipmentEvent, repeated: true },
    { no: 25, name: "estimated_delivery", kind: "message", T: Timestamp },
    { no: 26, name: "shipped_at", kind: "message", T: Timestamp },
    { no: 27, name: "delivered_at", kind: "message", T: Timestamp },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ShipmentEvent
 */
export const ShipmentEvent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ShipmentEvent",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shipment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "raw_payload", kind: "message", T: Struct },
    { no: 7, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Built-in delivery zones (no plugin needed)
 *
 * @generated from message omnios.v1.DeliveryZone
 */
export const DeliveryZone = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeliveryZone",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "postal_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DeliveryRate
 */
export const DeliveryRate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeliveryRate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "zone_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "method_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "max_weight_g", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "free_above_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.Address
 */
export const Address = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Address",
  () => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "building", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "apartment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "full_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "lng", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ConfigureDeliveryMethodRequest
 */
export const ConfigureDeliveryMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConfigureDeliveryMethodRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "supported_countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "config", kind: "message", T: Struct },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateDeliveryMethodRequest
 */
export const UpdateDeliveryMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateDeliveryMethodRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "config", kind: "message", T: Struct },
    { no: 5, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteDeliveryMethodRequest
 */
export const DeleteDeliveryMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteDeliveryMethodRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryMethodsRequest
 */
export const ListDeliveryMethodsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryMethodsRequest",
  () => [
    { no: 1, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryMethodsResponse
 */
export const ListDeliveryMethodsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryMethodsResponse",
  () => [
    { no: 1, name: "methods", kind: "message", T: DeliveryMethodConfig, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CalculateRatesRequest
 */
export const CalculateRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateRatesRequest",
  () => [
    { no: 1, name: "origin", kind: "message", T: Address },
    { no: 2, name: "destination", kind: "message", T: Address },
    { no: 3, name: "items", kind: "message", T: ShipmentItem, repeated: true },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ShipmentItem
 */
export const ShipmentItem = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ShipmentItem",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weight_g", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height_mm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "width_mm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "length_mm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculateRatesResponse
 */
export const CalculateRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateRatesResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: ShippingRate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateShipmentRequest
 */
export const CreateShipmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateShipmentRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "delivery_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "origin", kind: "message", T: Address },
    { no: 5, name: "destination", kind: "message", T: Address },
    { no: 6, name: "items", kind: "message", T: ShipmentItem, repeated: true },
    { no: 7, name: "customer", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.TrackShipmentRequest
 */
export const TrackShipmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TrackShipmentRequest",
  () => [
    { no: 1, name: "shipment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelShipmentRequest
 */
export const CancelShipmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelShipmentRequest",
  () => [
    { no: 1, name: "shipment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListShipmentsRequest
 */
export const ListShipmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListShipmentsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListShipmentsResponse
 */
export const ListShipmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListShipmentsResponse",
  () => [
    { no: 1, name: "shipments", kind: "message", T: Shipment, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetShipmentRequest
 */
export const GetShipmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetShipmentRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Zone management (built-in)
 *
 * @generated from message omnios.v1.CreateDeliveryZoneRequest
 */
export const CreateDeliveryZoneRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateDeliveryZoneRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "postal_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryZonesRequest
 */
export const ListDeliveryZonesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryZonesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryZonesResponse
 */
export const ListDeliveryZonesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryZonesResponse",
  () => [
    { no: 1, name: "zones", kind: "message", T: DeliveryZone, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.UpdateDeliveryZoneRequest
 */
export const UpdateDeliveryZoneRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateDeliveryZoneRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "postal_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteDeliveryZoneRequest
 */
export const DeleteDeliveryZoneRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteDeliveryZoneRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Rate management (built-in)
 *
 * @generated from message omnios.v1.CreateDeliveryRateRequest
 */
export const CreateDeliveryRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateDeliveryRateRequest",
  () => [
    { no: 1, name: "zone_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "method_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "max_weight_g", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "free_above_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateDeliveryRateRequest
 */
export const UpdateDeliveryRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateDeliveryRateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "max_weight_g", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "free_above_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteDeliveryRateRequest
 */
export const DeleteDeliveryRateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteDeliveryRateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryRatesRequest
 */
export const ListDeliveryRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryRatesRequest",
  () => [
    { no: 1, name: "zone_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDeliveryRatesResponse
 */
export const ListDeliveryRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeliveryRatesResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: DeliveryRate, repeated: true },
  ],
);

